module.exports = __webpack_public_path__ + "media/img/android-icon-48x48-92b0f13f8ea74c6cf604f79fb26ad18f.png";